import { Id } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { productKeys, productService } from "~shared/api/product/product_service";

const fetcher = (productId: Id) => () => productService.licenceCheck(productId).then((r) => r.data.data);

export const useProductLicenceCheckQuery = (productId: Id) => {
	return useQuery({ queryKey: productKeys.licenceCheck(productId), queryFn: fetcher(productId) });
};
